import { Flex } from '@auviknetworks/iceberg-ui';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const ExitSetupGuideLink = withTranslation()(
    ({
        'data-testid': dataTestid = 'exitSetupSaaSGuideLink',
        'data-trackid': dataTrackid = 'exitSetupSaaSGuideLink',
        link,
        onClick,
        t
    }) => (
        <Flex my={3}>
            <Link
                to={link}
                data-testid={dataTestid}
                data-trackid={dataTrackid}
                onClick={onClick}
                className="link--tertiary"
            >
                {t('Onboarding.footer.advancedSetup')}
            </Link>
        </Flex>
    )
);
